import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getCanonicalAndHreflang } from '../lib/i18n';

export default function GlobalHreflang() {
  const location = useLocation();
  const { lang, canonicalUrl, hreflangDa, hreflangEn, hreflangDefault } =
    getCanonicalAndHreflang(location.pathname);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <Helmet>
      <html lang={lang} />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang="da" href={hreflangDa} />
      <link rel="alternate" hrefLang="en" href={hreflangEn} />
      <link rel="alternate" hrefLang="x-default" href={hreflangDefault} />
    </Helmet>
  );
}
